import { connect } from 'react-redux';
import type { PaleState } from '@/interfaces';

import { actions as filterActions } from '@/state/filterActions';
import { fetchHotelResults } from '@/state/hotelResultActions';

import { OriginDropdown, type OriginDropdownProps } from './OriginDropdown';

const mapStateToProps = (state: PaleState): Pick<OriginDropdownProps, 'selectedValue'> => ({ selectedValue: state.filters.origin });

const mapDispatchToProps = { triggerFetch: fetchHotelResults, filterChange: filterActions.changeOrigin };

export default connect(mapStateToProps, mapDispatchToProps)(OriginDropdown);
